<template>
  <router-view :key="$route.fullPath" />
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "App",
});
</script>

<style lang="scss">
@import "@/sass/common-style.scss";
</style>
